import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import {
  IAPIStudioInfo,
  IAPIStudioMemberHasPermissionItem,
  RoleType,
} from '../../../model/api-modules';
import { IComponentProps } from '../../../model/studio';
import { getStudioInfo, getStudioMembersHasPermission } from '../../../api';
import { IRootState } from '../../../store/reducers';
import { useDispatch, useSelector } from 'react-redux';
import {
  ISelectStudioAction,
  ReduxStudioActionType,
} from '../../../store/modules/studio';
import { Dispatch } from 'redux';

interface IProps {
  readonly title: string | React.ReactNode;
  readonly renderComponent: (props: IComponentProps) => React.ReactNode;
  readonly className?: string;
  readonly renderCustomTitle?: (
    studioInfo: IAPIStudioInfo | null
  ) => string | React.ReactNode;
}

export const MainWrapper = (props: IProps) => {
  const selectStudioDispatch = useDispatch<Dispatch<ISelectStudioAction>>();
  const [loading, setLoading] = useState<boolean>(false);
  const [studioInfo, setStudioInfo] = useState<IAPIStudioInfo | null>(null);
  const [isOwner, setIsOwner] = useState<boolean>(false);
  const [owner, setOwner] = useState<IAPIStudioMemberHasPermissionItem>();
  const [members, setMembers] = useState<IAPIStudioMemberHasPermissionItem[]>(
    []
  );
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const currentURL = window.location.href;
  const urlParts = new URL(currentURL);
  const pathSegments = urlParts.pathname.split('/');
  const studioIndex = pathSegments.indexOf('studio');
  const studioID = pathSegments[studioIndex + 1];
  const studioList = useSelector(
    (state: IRootState) => state.studio.studioList
  );
  const selectStudio = studioList.find(
    (studio) => studio.studioID === studioID
  );
  useEffect(() => {
    reload();
  }, [studioID]);

  useEffect(() => {
    initialization();
  }, [location.pathname, selectStudio]);

  const initialization = async () => {
    setLoading(true);
    if (!selectStudio) {
      return false;
    }

    setStudioInfo({
      studio: {
        StudioID: selectStudio.studioID,
        Name: selectStudio.studioName,
        Creator: selectStudio.studioCreator,
        CreateTime: selectStudio.studioCreateTime,
      },
    });

    // const res = await getStudioMembers(studioID);
    const res = await getStudioMembersHasPermission(selectStudio.studioID);
    if (res) {
      setMembers(res);
      const ownerItem = res.find((item) =>
        item.RbacMember?.some((member) => member.roleType === RoleType.Owner)
      );
      if (ownerItem) {
        setOwner(ownerItem);
        setIsOwner(ownerItem.UserID === userInfo?.UserID);
      }
    }

    setLoading(false);
    return !!res;
  };

  const reload = async () => {
    if (!selectStudio?.studioID) {
      return false;
    }
    setLoading(true);
    const resInfo = await getStudioInfo(selectStudio.studioID);
    setStudioInfo(resInfo.data ? resInfo.data : null);
    selectStudioDispatch({
      type: ReduxStudioActionType.SELECT_STUDIO,
      result: {
        ...selectStudio,
        studioName: resInfo.data?.studio?.Name || selectStudio.studioName,
      },
    });
    setLoading(false);
    return true;
  };

  const renderComponent = () => {
    if (studioInfo) {
      return props.renderComponent({
        studioInfo,
        isOwner,
        loading,
        onReload: reload,
        owner,
        members,
      });
    }
    return null;
  };

  const className = classNames(styles.pageContentMain, props.className);

  return <div className={className}>{renderComponent()}</div>;
};
